export const IconLoupe = ({ active = false }: { active?: boolean }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      style={active ? { filter: 'drop-shadow(0 0 2px rgba(255,255,255,0.9))' } : undefined}
    >
      <circle cx="10" cy="10" r="6.5" stroke="#fff" strokeWidth="2" />
      <path d="M14.5 14.5L20 20" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
    </svg>
  )
}
